import { render } from "./AmountModal.vue?vue&type=template&id=986c1b24&scoped=true"
import script from "./AmountModal.vue?vue&type=script&lang=js"
export * from "./AmountModal.vue?vue&type=script&lang=js"

import "./AmountModal.vue?vue&type=style&index=0&id=986c1b24&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-986c1b24"]])

export default __exports__